var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlider(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 32.02C37.1 32.02 38 32.92 38 34.02V36C38 40.4 35 44 30 44H18C13 44 10 40.4 10 36V34.02C10 32.92 10.9 32.02 12 32.02H36Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 12V27C38 28.1 37.1 29 36 29H12C10.9 29 10 28.1 10 27V12C10 7.60003 13 4.00003 18 4.00003H30C35 4.00003 38 7.60003 38 12Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 41.5C5.18 41.5 4.5 40.82 4.5 40V7.99997C4.5 7.17997 5.18 6.49997 6 6.49997C6.82 6.49997 7.5 7.17997 7.5 7.99997V40C7.5 40.82 6.82 41.5 6 41.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41.5C41.18 41.5 40.5 40.82 40.5 40V7.99997C40.5 7.17997 41.18 6.49997 42 6.49997C42.82 6.49997 43.5 7.17997 43.5 7.99997V40C43.5 40.82 42.82 41.5 42 41.5Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.ce6bd846641b78c30fd2e8f0686ced92.svg";
export { ForwardRef as ReactComponent };